export type AppearanceMode = "light" | "dark" | "system";

export type AppearanceSource = "manual" | "solar";

export type AppearanceTheme =
  | "negative"
  | "magic-hour"
  | "slate"
  | "tungsten"
  | "daylight"
  | "noir"
  | "velvet"
  | "silver-screen"
  | "red-carpet"
  | "green-room"
  | "cobalt"
  | "paper"
  | "sage"
  | "charcoal";

export type ThemeCategory = "cinematic" | "single-color" | "updated-classics";

export type AppearanceFont =
  | "inter-tight"
  | "lato"
  | "system"
  | "geometric"
  | "courier"
  | "reading";

export type AppearanceFontSize = "compact" | "default" | "comfortable" | "large";

export type ResolvedAppearanceMode = "light" | "dark";

export type SavedManualAppearance = {
  mode: AppearanceMode;
  theme: AppearanceTheme;
};

export type AppearancePreferences = {
  source: AppearanceSource;
  mode: AppearanceMode;
  theme: AppearanceTheme;
  font: AppearanceFont;
  fontSize: AppearanceFontSize;
  savedManual?: SavedManualAppearance;
};

export const APPEARANCE_STORAGE_KEY = "rivetai-appearance";

export const DEFAULT_APPEARANCE: AppearancePreferences = {
  source: "manual",
  mode: "dark",
  theme: "magic-hour",
  font: "inter-tight",
  fontSize: "default",
};

export const APPEARANCE_SOURCES: AppearanceSource[] = ["manual", "solar"];

export const APPEARANCE_THEMES: AppearanceTheme[] = [
  "negative",
  "magic-hour",
  "slate",
  "tungsten",
  "daylight",
  "noir",
  "velvet",
  "silver-screen",
  "red-carpet",
  "green-room",
  "cobalt",
  "paper",
  "sage",
  "charcoal",
];

export const APPEARANCE_FONTS: AppearanceFont[] = [
  "inter-tight",
  "lato",
  "system",
  "geometric",
  "courier",
  "reading",
];

export const APPEARANCE_FONT_SIZES: AppearanceFontSize[] = [
  "compact",
  "default",
  "comfortable",
  "large",
];

export const APPEARANCE_MODES: AppearanceMode[] = ["light", "dark", "system"];
